module.exports = __webpack_public_path__ + "static/img/A169.2e19b36b.jpg";